import { Coordinates } from "../../Util/Math/Coordinates"
import { FretBoardNote } from "../FretBoard/FretBoardV2"

export class FretBoardNoteCtrlMenuState{
    setter:Function
    note:FretBoardNote|null
    selectedNotes:FretBoardNote[] = []
    coordinates:Coordinates
    isOpen:boolean
    refresh:Function
    drawLines:Function
    constructor(setter:Function){
      this.isOpen = false
      this.setter = setter
      this.note = null
      this.coordinates = new Coordinates(200,200)
      this.refresh = () => {}
      this.drawLines = () => {}
    }
    setIsOpen = (b:boolean) => {
      const openSetter = (state:FretBoardNoteCtrlMenuState)=>{
        return({ isOpen:b})
      }
      this.setter(openSetter)
    }
    setNote = (note:FretBoardNote) => {
      const noteSetter = (state:FretBoardNoteCtrlMenuState)=>{
        return({ note: note })
      }
      this.setter(noteSetter)
    }
    setCoordinates = (coords:Coordinates) => {
      const coordsSetter = (state:FretBoardNoteCtrlMenuState)=>{
        return({ coordinates: coords })
      }
      this.setter(coordsSetter)     
    }
    setNoteConfig = (note:FretBoardNote, coords:Coordinates, refresh:Function, selectedNotes:FretBoardNote[], drawLines:Function) => {
     const configSetter = (state:FretBoardNoteCtrlMenuState)=>{
        return({ isOpen:true, coordinates: coords, note:note, refresh:refresh, selectedNotes:selectedNotes, drawLines:drawLines })
      }
      this.setter(configSetter)
    }
    setState = (obj:any) => {
      this.setter((state:FretBoardNoteCtrlMenuState) => (obj))
    }
  }